export default {
  // getIsAdFunctionAdd: state => state.isAdd,
  // getIsLoading: state => state.isLoading,
  getAdFunction: state => state.adFunction,
  getAdFunctions: state => state.adFunctions,
}
